export const projectTitle = "New Year Stories";
export const lightBackgroundColor = "#C9C60A";
export const darkBackgroundColor = "#001e3c";